import apiClient from "../api";

export const getCustomerBillingHistory = (id, header) => apiClient.get(`/billing-history?customerId=${id}`, header);